const styles = {
    overlay: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
        background: "rgba(0,0,0,0.14)",
        zIndex: 1500,
    },
    modal: {
        maxWidth: 720,
        minWidth: 410,
        width: "100%",
        borderRadius: 2,
        p: "16px 22px 24px 22px",
        boxShadow: "0px 8px 34px 4px rgba(0,0,0,0.18)",
        position: "relative",
        background: "#fff",
        outline: "none",
    },
    header: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        mb: 0,
    },
    title: {
        fontSize: 20,
        fontWeight: 600,
        color: "#212529",
    },
    closeBtn: {
        position: "absolute",
        right: 20,
        top: 15,
    },
    desc: {
        fontSize: 15,
        color: "#555",
        mt: 0.6,
        mb: 2,
        fontWeight: 400,
    },
    section: {
        fontSize: 17,
        fontWeight: 600,
        mb: 2,
        mt: 2,
    },
    tableCard: {
        background: "#fafbfc",
        borderRadius: 2.2,
        p: "9px 0 10px 0",
        mb: 2,
        border: "1.2px solid #ededed",
        overflowX: 'auto',
        maxHeight: 320,
        minHeight: 70,
        overflowY: 'auto',
    },
    thCell: {
        fontWeight: 500,
        fontSize: 15,
        color: "#111",
        background: "#F9F9F9",
        borderBottom: "1.5px solid #E6E6E6",
        padding: "13px 0 13px 10px",
        whiteSpace: 'nowrap'
    },
    tdCell: {
        background: "#fafbfc",
        padding: "9px 0 9px 10px",
        borderBottom: "none",
        borderTop: 'none'
    },
    input: {
        background: "#fff",
        fontSize: 15,
        boxSizing: "border-box",
        width: "100%",
        mt: "0 !important",
        // padding : '7px 16px !important'
    },
    deleteBtn: {
        color: "#E43A36",
        "& svg": {
            fontSize: "20px !important",
        },
        ml: 0.5
    },
    totalLabel: {
        textAlign: "right",
        fontWeight: 500,
        fontSize: 16,
        borderTop: "1.5px solid #E6E6E6",
        background: "#fafbfc",
        pr: 2,
        padding: '6px 10px 0 0',
        borderBottom: '0 !important'
    },
    totalValue: {
        textAlign: "left",
        fontWeight: 500,
        fontSize: 16,
        color: "#222",
        background: "#fafbfc",
        borderTop: "1.5px solid #E6E6E6",
        borderBottom: '0 !important',
        pl: 2,
        padding: '6px 0 0 14px',
    },
    addBtn: {
        border: "1.4px solid rgb(132, 132, 132)",
        color: "rgb(0, 0, 0)",
        background: "#fff",
        fontWeight: 400,
        textTransform: "none",
        borderRadius: 2,
        fontSize: 14,
        justifyContent: "flex-start",
    },
    saveBtn: {
        borderRadius: 2,
        fontSize: 16,
        letterSpacing: 0.5,
        background: "#14C12A",
        color: "#fff",
        px: 3,
        textTransform: "none",
        "&:hover": {
            background: "#12b826",
        },
    },
    row: {
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
        width: "100%",
        mt: 3,
        mb: 0,
    },
};

export default styles;